import React from "react";

interface NumProps {
  className?: string;
  children: React.ReactNode;
}

/** A number is data, not language. Google Translate rewrites a bare digit into a whole sentence,
 *  which then overflows whatever the digit was sized to fit. */
export const Num: React.FC<NumProps> = ({ className, children }) => (
  <span
    className={className ? `${className} notranslate` : "notranslate"}
    translate="no"
  >
    {children}
  </span>
);
